import React, { useState } from "react";

export default function BatchManager({ 
  title = "Sustina Batch Manager", 
  batchType, 
  onStart, 
  isSubmitting, 
  error, 
  successMessage 
}) {
  const [files, setFiles] = useState([]);
  const [description, setDescription] = useState("");
  // 🎯 Master State: Store physical stats as static numbers immediately
  const [stats, setStats] = useState({ totalBatchSizeMB: 0, fileCount: 0 });

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    
    // 🎯 PHYSICAL RETRIEVAL: Calculate NOW to prevent "undefined" later
    const addedBytes = newFiles.reduce((acc, f) => acc + (f.size || 0), 0);
    const addedMB = parseFloat((addedBytes / (1024 * 1024)).toFixed(2));

    setFiles((prev) => [...prev, ...newFiles]);
    setStats((prev) => ({
      totalBatchSizeMB: prev.totalBatchSizeMB + addedMB,
      fileCount: prev.fileCount + newFiles.length
    }));
  };

  const removeFile = (index) => {
    const fileToRemove = files[index];
    const removedMB = parseFloat((fileToRemove.size / (1024 * 1024)).toFixed(2));
    
    setFiles((prev) => prev.filter((_, i) => i !== index));
    setStats((prev) => ({
      totalBatchSizeMB: Math.max(0, prev.totalBatchSizeMB - removedMB),
      fileCount: prev.fileCount - 1
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (files.length === 0) return;

    // 🎯 Match the keys exactly as SustinaTaxonomyView expects them
    onStart({ 
      file: files[0], 
      batchType: batchType, 
      description: description,
      totalBatchSizeMB: stats.totalBatchSizeMB, // Matches View
      fileCount: stats.fileCount                // Matches View
    });
  };

  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark fw-bold">{title}</h5>
        <span className="badge bg-secondary">{stats.totalBatchSizeMB.toFixed(2)} MB</span>
      </div>

      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label small fw-bold">Batch Description</label>
            <input
              type="text"
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="e.g. ESRS Taxonomy Sync"
            />
          </div>

          <div 
            className="upload-zone p-4 border rounded bg-light text-center border-dashed mb-4"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              handleFileChange({ target: { files: e.dataTransfer.files } });
            }}
          >
            <input type="file" multiple className="d-none" id="fileInput" onChange={handleFileChange} />
            <label htmlFor="fileInput" style={{ cursor: 'pointer', width: '100%' }}>
              <img src="/icons/2D2C31_document.png" alt="doc" style={{ width: "40px" }} className="mb-2" />
              <p className="mb-0 small fw-bold">Click to add files</p>
            </label>
          </div>

          {files.map((f, i) => (
            <div key={i} className="list-group-item d-flex justify-content-between align-items-center mb-1 rounded border p-2 bg-white">
              <div className="d-flex align-items-center overflow-hidden">
                <img src="/icons/2D2C31_document.png" alt="file" style={{ width: "20px" }} className="me-2" />
                <span className="small text-truncate" style={{maxWidth: '200px'}}>{f.name}</span>
                <span className="ms-2 text-muted small">({(f.size / 1024 / 1024).toFixed(2)} MB)</span>
              </div>
              <button type="button" className="btn btn-sm text-danger" onClick={() => removeFile(i)}>&times;</button>
            </div>
          ))}

          <button type="submit" className="btn btn-dark w-100 fw-bold mt-3" disabled={files.length === 0 || isSubmitting}>
            {isSubmitting ? "Initiating Sequence..." : "Start Batch Process"}
          </button>
        </form>
        {error && <div className="alert alert-danger mt-3 small">{error}</div>}
      </div>
    </div>
  );
}